import React from "react";
import { MoreHoriz } from "@material-ui/icons";
import { IconButton, Menu } from "@mui/material";

import styles from "./MenuButton.module.scss";

interface MenuButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
}

export const MenuButton: React.FC<MenuButtonProps> = ({ children, disabled }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <IconButton
        className={styles.iconButton}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        disabled={disabled}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        className={styles.menu}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClick={() => setAnchorEl(null)}
      >
        {children}
      </Menu>
    </>
  );
};
